<template><section><h2>雷达图数据更新</h2>
<block-demo tip="数据更新" source="const data = [
  { label: &#39;客服&#39;, category: &#39;实际开销&#39;, value: 2 },
  { label: &#39;研发&#39;, category: &#39;实际开销&#39;, value: 22 },
  { label: &#39;市场&#39;, category: &#39;实际开销&#39;, value: 69 },
  { label: &#39;扯淡&#39;, category: &#39;实际开销&#39;, value: 69 },
  { label: &#39;销售&#39;, category: &#39;实际开销&#39;, value: 66 },
  { label: &#39;管理&#39;, category: &#39;实际开销&#39;, value: 32 },
  { label: &#39;技术&#39;, category: &#39;实际开销&#39;, value: 24 },

  { label: &#39;客服&#39;, category: &#39;节能减排&#39;, value: 100 },
  { label: &#39;研发&#39;, category: &#39;节能减排&#39;, value: 47 },
  { label: &#39;市场&#39;, category: &#39;节能减排&#39;, value: 73 },
  { label: &#39;扯淡&#39;, category: &#39;节能减排&#39;, value: 48 },
  { label: &#39;销售&#39;, category: &#39;节能减排&#39;, value: 10 },
  { label: &#39;管理&#39;, category: &#39;节能减排&#39;, value: 41 },
  { label: &#39;技术&#39;, category: &#39;节能减排&#39;, value: 32 }
]

const { Chart, Radar, Tooltip, Legend } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})
chart.source(data, {
  row: &#39;category&#39;,
  value: &#39;value&#39;,
  text: &#39;label&#39;
})

const radar = new Radar()

chart.append(new Legend())

const data2 = [
  { label: &#39;客服&#39;, category: &#39;添加测试&#39;, value: 130 },
  { label: &#39;研发&#39;, category: &#39;添加测试&#39;, value: 92 },
  { label: &#39;市场&#39;, category: &#39;添加测试&#39;, value: 70 },
  { label: &#39;扯淡&#39;, category: &#39;添加测试&#39;, value: 65 },
  { label: &#39;销售&#39;, category: &#39;添加测试&#39;, value: 21 },
  { label: &#39;管理&#39;, category: &#39;添加测试&#39;, value: 66 },
  { label: &#39;技术&#39;, category: &#39;添加测试&#39;, value: 70 }
]

let change = true
setInterval(() =&gt; {
  if (change) {
    chart.source(data2)
  } else {
    chart.source(data)
  }
  change = !change
}, 3000)

chart.append(radar)
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'客服'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'实际开销'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">2</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'研发'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'实际开销'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">22</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'市场'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'实际开销'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">69</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'扯淡'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'实际开销'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">69</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'销售'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'实际开销'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">66</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'管理'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'实际开销'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">32</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'技术'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'实际开销'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">24</span> },

  { <span class="hljs-attr">label</span>: <span class="hljs-string">'客服'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'节能减排'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">100</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'研发'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'节能减排'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">47</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'市场'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'节能减排'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">73</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'扯淡'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'节能减排'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">48</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'销售'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'节能减排'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">10</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'管理'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'节能减排'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">41</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'技术'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'节能减排'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">32</span> }
]

<span class="hljs-keyword">const</span> { Chart, Radar, Tooltip, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'category'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'label'</span>
})

<span class="hljs-keyword">const</span> radar = <span class="hljs-keyword">new</span> Radar()

chart.append(<span class="hljs-keyword">new</span> Legend())

<span class="hljs-keyword">const</span> data2 = [
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'客服'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'添加测试'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">130</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'研发'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'添加测试'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">92</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'市场'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'添加测试'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">70</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'扯淡'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'添加测试'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">65</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'销售'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'添加测试'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">21</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'管理'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'添加测试'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">66</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'技术'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'添加测试'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">70</span> }
]

<span class="hljs-keyword">let</span> change = <span class="hljs-literal">true</span>
setInterval(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
  <span class="hljs-keyword">if</span> (change) {
    chart.source(data2)
  } <span class="hljs-keyword">else</span> {
    chart.source(data)
  }
  change = !change
}, <span class="hljs-number">3000</span>)

chart.append(radar)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>